import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import FadeInSection from '@/components/base/FadeInSection';
import HeroSection from './components/HeroSection';
import HotRecommend from './components/HotRecommend';
import CategoryGrid from './components/CategoryGrid';
import LatestContent from './components/LatestContent';
import FAQSection from './components/FAQSection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '亚洲视频精选平台',
  url: 'https://axpar.cn',
  description: '亚洲视频一站式聚合平台，汇集来自日韩、东南亚、华语地区的精品视频内容。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://axpar.cn/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchema) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <FadeInSection><HotRecommend /></FadeInSection>
        <FadeInSection><CategoryGrid /></FadeInSection>
        <FadeInSection><LatestContent /></FadeInSection>
        <FadeInSection><FAQSection /></FadeInSection>
      </main>
      <Footer />
    </>
  );
}